import styled from "styled-components";

import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { StyledColumn, StyledFlex } from "./layout";
import { Spacer } from "../Spacer";
import { IconCircle } from "../IconCircle";
import { TextCapitalized } from "../text/TextCapitalized";

export interface StatCardProps {
  icon: JSX.Element;
  value: string;
  unit?: string;
  label: string;
  onClick?: () => void;
}

export const StatCard = ({
  icon,
  value,
  unit,
  label,
  onClick,
}: StatCardProps) => (
  <StyledCard
    as={onClick ? "button" : "div"}
    type={onClick ? "button" : undefined}
    onClick={onClick}
    $clickable={onClick !== undefined}
  >
    <Spacer y={1.5} />
    <StyledRow>
      <Spacer x={1} />
      <StyledContent>
        <IconCircle icon={icon} backgroundColor="textWhite" />
        <Spacer y={1} />
        <StyledValue>
          {value}
          {unit && (
            <>
              <Spacer x={0.25} />
              <StyledUnit>{unit}</StyledUnit>
            </>
          )}
        </StyledValue>
        <Spacer y={0.5} />
        <StyledLabelRow>
          <TextCapitalized>{label}</TextCapitalized>
          {onClick && (
            <>
              <Spacer x={0.5} />→
            </>
          )}
        </StyledLabelRow>
      </StyledContent>
      <Spacer x={1} />
    </StyledRow>
    <Spacer y={1.5} />
  </StyledCard>
);

const StyledCard = styled.div<{ $clickable: boolean }>`
  all: unset;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background: ${colors["colors/surfaces/background/background_level1"]};
  border-radius: 0.75rem;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
`;

const StyledRow = styled(StyledFlex)`
  width: 100%;
`;

const StyledContent = styled(StyledColumn)`
  flex: 1;
  min-width: 0;
  align-items: flex-start;
`;

const StyledValue = styled(StyledFlex)`
  align-items: baseline;
  ${typographies["Header/H1"]}
  color: ${colors["colors/text/black"]};
`;

const StyledUnit = styled.span`
  ${typographies["Body/XS"]}
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledLabelRow = styled(StyledFlex)`
  width: 100%;
  align-items: center;
  ${typographies["Body/S"]}
  color: ${colors["colors/text/darkGrey"]};
`;
